<template>
  <section class="tips-section" aria-labelledby="tips-title">
    <header class="main-header">
      <img src="../../assets/tips/mitumori.png" alt="">
    </header>

    <article class="content-card" aria-label="見積もりの安心ポイント">
      <p class="lead">
        当サイト掲載業者の見積もりは、次の点で安心してご利用いただけます。
      </p>

      <ul class="points-list">
        <li>見積もりだけでもOK</li>
        <li>金額に満足できなければキャンセルOK</li>
        <li>見積もり後にしつこい営業なし</li>
      </ul>
      <h3 class="sub-title">無料見積もりを依頼することで</h3>
      <ul class="benefits-list">
        <li>本体＋工事費の<span class="bold-red"> 総額を事前に把握できる</span></li>
        <li>お住まいのエリアで<span class="bold-red"> 最短いつ設置可能かがわかる</span></li>
        <li><span class="bold-red"> 業者の雰囲気がわかる</span></li>
      </ul>
      <p class="description">
        少しでも気になった業者にまずは見積もりを取り、
        対応スピード・価格・担当者の対応を比較してから決めるのが最も安心です。
      </p>
    </article>
  </section>
</template>

<style scoped>
.tips-section {
  max-width: 760px;
  color: #2b2b2b;
  box-sizing: border-box;
  background: #eef5ff;
  text-align: left;
  padding-bottom: 20px;
}

.main-title {
  margin: 0;
  font-weight: 800;
  font-size: 1.6rem;
  line-height: 1.35;
  color: #263238;
}

.main-header img {
  width: 100%;
}

/* ===== カード ===== */
.content-card {
  border: 2px solid #ececec;
  border-radius: 8px;
  padding: 20px;
  background: #fff;
  margin: 0 20px;
}

.lead {
  margin: 0 0 10px;
  font-size: 0.87rem;
  line-height: 1.8;
  color: #444;
}

.description {
  margin: 10px 0 14px;
  font-size: .87rem;
  line-height: 1.9;
  color: #444;
}

.hl {
  color: #e53935;
  font-weight: 700;
}

/* ===== 安心ポイント（控えめ・読みやすく） ===== */
.points-list {
  list-style: none;
  padding: 0;
  margin: 12px 0 10px;
  /* ← 余白を少し拡大 */
}

.points-list li {
  position: relative;
  padding-left: 1em;
  padding-top: 4px;
  padding-bottom: 6px;
  color: #333;
  font-size: 0.9rem;
}

.points-list li:last-child {
  border-bottom: none;
}

.points-list li::before {
  content: "✔";
  position: absolute;
  left: 0;
  top: 0.05em;
  color: #2a8f4a;
  /* 落ち着いた緑の小さなチェック */
  font-weight: 900;
  font-size: .9em;
}

/* ===== メリット（既存デザイン据え置き：青バー＋白枠） ===== */
.sub-title {
  margin: 12px 0 0;
  padding: 12px 14px;
  font-size: 1rem;
  font-weight: 800;
  color: #fff;
  background: #1f49a4;
  border-radius: 10px 10px 0 0;
}

.benefits-list {
  list-style: disc;
  list-style-position: outside;
  margin: 0;
  padding: 12px 16px 14px 32px;
  border: 1px solid #2f2f2f;
  border-top: none;
  background: #fff;
}

.benefits-list li {
  margin: 8px 0;
  line-height: 1.8;
  color: #2f2f2f;
  font-size: 0.9rem;
}

.benefits-list strong {
  font-weight: 800;
}

@media (max-width: 560px) {
  .main-title {
    font-size: 1.4rem;
  }

  .lead,
  .description,
  .benefits-list li {
    font-size: .95rem;
  }

  .sub-title {
    padding: 10px 12px;
  }

  .benefits-list {
    padding: 10px 14px 12px 28px;
  }

  .content-card {
    margin: 0 10px;
  }
}
</style>
